import { IApplicationState } from '../../types/redux';

export const selectDemandRequest = (state: IApplicationState) => state.dataPayment.demandRequest;
